export default async function session() {
  return await import(
    /* webpackChunkName: "session" */ '@buzzfeed/user-pathing/session'
  );
}
